import * as marietta3d from '..';
import { Geometry } from './utils';
import * as marietta from '../../marietta';

export default class AutoDimension {
        private autoBase: marietta3d.AutoGen.AutoBase;

        private Geom: marietta3d.AutoGen.utils.Geometry;

        /*------------------------------------------------------
        * constructor
        */
        constructor(base: marietta3d.AutoGen.AutoBase) {
          this.autoBase = base;
          this.Geom = new marietta3d.AutoGen.utils.Geometry();
        }

        /*------------------------------------------------------
        * 寸法自動生成（生成済なら削除する）
        *
        */
        public AGDimension(flr: number) {
          if (this.autoBase.dimExist[flr] === true) {
            /* 削除 */
            this.autoBase.dimExist[flr] = false;
            this.ClearDimension(flr);
          }
          /* 生成 */
          this.autoBase.dimExist[flr] = true;

          /* 指定された階のすべての部屋の外周を作る */
          const source = [];
          const result = [];
          const resultHole = [];
          for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
            const pheya = this.autoBase.HeyaList[flr - 1][i];
            const plg = new marietta3d.AutoGen.utils.RoomPointArray();
            plg.CopyFrom(pheya.points);
            source.push(plg);
          }
          Geometry.MargePolygon(source, result, resultHole);

          for (let n = 0; n < result.length; n += 1) {
            const pol = result[n];
            const min = new marietta.core.Point(0, 0, 0);
            const max = new marietta.core.Point(0, 0, 0);
            pol.GetPolygonMinMax(min, max); /* 外周のMinMax */
            const rect = new marietta3d.AutoGen.utils.RoomPointArray();
            const rect2 = new marietta3d.AutoGen.utils.RoomPointArray();
            const cadPitch = this.autoBase.scaleObj.GetModulePitch(); // WebCAD Pitch : 60
            rect.Add(new marietta.core.Point(min.x, min.y, 0));
            rect.Add(new marietta.core.Point(max.x, min.y, 0));
            rect.Add(new marietta.core.Point(max.x, max.y, 0));
            rect.Add(new marietta.core.Point(min.x, max.y, 0));
            rect.GetOffsetPolygon(rect2, -cadPitch, 1); /* １P太らせる */
            for (let i = 0; i < rect2.length; i += 1) {
              this.AGDimensionSub(flr, rect2[i], rect2[(i + 1) % rect2.length], pol);
            }
          }
        }

        /*------------------------------------------------------
        * 寸法自動メイン
        *
        */
        private AGDimensionSub(flr: number, p1: marietta.core.Point, p2: marietta.core.Point, gai: marietta3d.AutoGen.utils.RoomPointArray) {
          const cr = new marietta.core.Point(0, 0, 0);
          const ko = new marietta3d.AutoGen.utils.RoomPointArray();
          ko.Add(new marietta.core.Point(p1.x, p1.y, 0));
          ko.Add(new marietta.core.Point(p2.x, p2.y, 0));
          const ln = new marietta3d.AutoGen.utils.RoomEdge();
          ln.CopyPointFrom(p1, p2);
          for (let j = 0; j < this.autoBase.HeyaList[flr - 1].length; j += 1) {
            const pheya = this.autoBase.HeyaList[flr - 1][j];
            for (let i = 0; i < pheya.points.length; i += 1) {
              const po = pheya.points[i];
              if (ln.VerticalIntersection(po, cr)) {
                const lcr = new marietta3d.AutoGen.utils.RoomPointArray();
                gai.IsIncludeLineAtPolygon(po, cr, lcr, false, marietta3d.AutoGen.utils.ALMOST_ZERO, true, true);
                if (lcr.length === 0) {
                  ko.Add(new marietta.core.Point(cr.x, cr.y, 0));
                }
              }
            }
          }

          ko.PointSort(p1, p2);

          for (let i = 1; i < ko.length - 2; i += 1) {
            const k1 = new marietta.core.Point(0, 0, 0);
            const k2 = new marietta.core.Point(0, 0, 0);
            const k1w = new marietta.core.Point(0, 0, 0);
            const k2w = new marietta.core.Point(0, 0, 0);
            ko.CopyPoint(i, k1w, k2w);
            const dim = Math.floor(this.autoBase.scaleObj.ConvertCadToWorld(k1w.distanceTo(k2w)));
            const wln = new marietta3d.AutoGen.utils.RoomEdge();
            wln.CopyPointFrom(k1w, k2w);
            wln.GetOffsetEdge(-30);
            const dt = new marietta3d.AutoGen.object.AutoObjDimension(flr, k1, k2, k1w, k2w, dim.toString());
            dt.p1.copyFrom(wln.s);
            dt.p2.copyFrom(wln.e);
            this.autoBase.DimensionAdd(dt);
          }
          if (ko.length > 4) {
            let no = 1;
            const k1w = new marietta.core.Point(ko[no].x, ko[no].y, 0);
            no = ko.length - 2;
            const k2w = new marietta.core.Point(ko[no].x, ko[no].y, 0);
            const k1 = new marietta.core.Point(0, 0, 0);
            const k2 = new marietta.core.Point(0, 0, 0);
            const wln = new marietta3d.AutoGen.utils.RoomEdge();
            wln.GetPointFrom(k1w, k2w);
            wln.GetOffsetEdge(-30);
            const dim = Math.floor(this.autoBase.scaleObj.ConvertCadToWorld(wln.s.distanceTo(wln.e)));
            const dt = new marietta3d.AutoGen.object.AutoObjDimension(flr, k1, k2, k1w, k2w, dim.toString());
            const wln2 = new marietta3d.AutoGen.utils.RoomEdge();
            wln2.CopyPointFrom(wln.s, wln.e);
            wln2.GetOffsetEdge(-30);
            dt.p1.copyFrom(wln2.s);
            dt.p2.copyFrom(wln2.e);
            this.autoBase.DimensionAdd(dt);
          }
        }

        /*------------------------------------------------------
        * ClearDimension
        *
        */
        private ClearDimension(flr: number) {
          for (let j = 0; j < this.autoBase.DimensionList[flr - 1].length; j += 1) {
            delete this.autoBase.DimensionList[flr - 1][j];
          }
          this.autoBase.DimensionList[flr - 1].splice(0, this.autoBase.DimensionList[flr - 1].length);
        }
}
